import { CustomerDocument, useCustomerQuery } from '@graphcommerce/magento-customer'
import { extendableComponent } from '@graphcommerce/next-ui'
import { i18n } from '@lingui/core'
import Head from 'next/head'
import { useEffect, useState } from 'react'
import { CategoryQuestionAndAnswerItem } from './CategoryQuestionAndAnswerItem'

export type CategoryQuestionsAndAnswersProps = {
  productId?: number | null | undefined
  productTitle?: string | null | undefined
  productUrl?: string | null | undefined
  qaData: any[] | null | undefined
  displayInTab?: boolean
  displayInHomePage?: boolean
}

export function CategoryQuestionsAndAnswers(props: CategoryQuestionsAndAnswersProps) {
  const {
    productId,
    productUrl,
    productTitle,
    qaData,
    displayInTab = true,
    displayInHomePage,
  } = props
  const [productQuestionsData, setProductQuestionsData] = useState<any[] | null | undefined>([]) // reviewData.response.bottomline

  const name = 'ImageText' as const
  const parts = ['root'] as const
  const { classes } = extendableComponent(name, parts)

  const closeOnConfirm = () => {}

  const questionAndAnswerStructuredData = productQuestionsData?.map((qAndA) => ({
    '@type': 'Question',
    name: qAndA.title,
    acceptedAnswer: {
      '@type': 'Answer',
      text: `<p>${qAndA.short_answer}</p>`,
    },
  }))

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: questionAndAnswerStructuredData,
  }

  useEffect(() => {
    if (qaData && qaData.length > 0) {
      setProductQuestionsData(qaData)
    } else {
      setProductQuestionsData([])
    }
  }, [qaData])

  return (
    <div className={`${classes.root} ${displayInTab ? 'mb-[200px]' : ''}`}>
      {questionAndAnswerStructuredData && questionAndAnswerStructuredData?.length > 0 && (
        <Head>
          <script
            type='application/ld+json'
            dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
          />
        </Head>
      )}
      {(!productQuestionsData || productQuestionsData?.length < 1) && !displayInHomePage && (
        <div className='Type-XXXL-Regular mx-[20px] my-[80px] flex flex-col items-start justify-center'>
          <span className='md:Type-XL-Regular Type-Large-Regular'>
            There are no questions specific to this product or category yet. You may visit{' '}
            <a href='https://templi.gorgias.help/' className='text-teal underline'>
              Templi's FAQ page
            </a>{' '}
            for answers to more general questions.
          </span>
        </div>
      )}
      {productQuestionsData && productQuestionsData?.length > 0 && (
        <div
          className='
            flex w-full flex-col items-start justify-items-start gap-x-8 gap-y-8 md:grid md:grid-cols-2 md:gap-y-10'
        >
          {productQuestionsData
            ?.filter((item) => item.status === 1)
            .map((question) => (
              <CategoryQuestionAndAnswerItem {...question} />
            ))}
        </div>
      )}
    </div>
  )
}
